<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const title = field<string>("title", "");
const subtitle = field<string>("subtitle", "");
const logo = field<string>("logo", "");
const backgroundImage = field<string>("backgroundImage", "");
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:book-image" accent="reporting">
    <EditorField :label="t('fields.title.label')">
      <Input
        v-model="title"
        class="h-8 rounded-sm bg-muted text-[13px]"
        :placeholder="t('fields.title.placeholder')"
      />
    </EditorField>

    <EditorField :label="t('fields.subtitle.label')">
      <Input
        v-model="subtitle"
        class="h-8 rounded-sm bg-muted text-[13px]"
        :placeholder="t('fields.subtitle.placeholder')"
      />
    </EditorField>

    <EditorField :label="t('fields.logo.label')" :hint="t('fields.logo.hint')">
      <Input
        v-model="logo"
        class="h-8 rounded-sm bg-muted text-[13px]"
        :placeholder="t('fields.logo.placeholder')"
      />
    </EditorField>

    <EditorField :label="t('fields.backgroundImage.label')" :hint="t('fields.backgroundImage.hint')">
      <Input
        v-model="backgroundImage"
        class="h-8 rounded-sm bg-muted text-[13px]"
        :placeholder="t('fields.backgroundImage.placeholder')"
      />
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Cover Page"
  fields:
    title:
      label: "Title"
      placeholder: "Enter a cover title"
    subtitle:
      label: "Subtitle"
      placeholder: "Enter a cover subtitle"
    logo:
      label: "Logo"
      hint: "URL or data URI for the PDF compiler."
      placeholder: "https://example.com/logo.svg"
    backgroundImage:
      label: "Background Image"
      hint: "URL or data URI for the PDF compiler."
      placeholder: "https://example.com/background.jpg"
</i18n>
